import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
// import {MDBModalRef,MDBModalService}  from 'angular-bootstrap-md';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfigLoaderService } from '../../Services/Config/config-loader.service';
import { ContactusService } from "../../Services/Contactus/contactus-service"
import { Contactus, UseCase, ClientIndustry, ClientMarket } from "../../Model/contactus/contactus-model";
declare var $: any;
import {ErrorModel} from '../../Model/error/error-model';
import {ErrorServiceService} from '../../Services/Error/error-service.service'


@Component({
    selector: 'app-contact-modal',
    templateUrl: './contact-modal.component.html',
    styleUrls: ['./contact-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactModalComponent implements OnInit {

  contactmodel: Contactus = new Contactus();
  usecaselist!: UseCase[];
  clientmarketlist!: ClientMarket[];
  clientindustrylist!: ClientIndustry[];
  @ViewChild('contactusform') contactform!: NgForm;
  showalertMsg: boolean = false;
  alertMsg!:string;
  successMessage: string="Thank you for reaching out to us. Our team will get in touch with you soon.";
  ErrorMessage: string="Error in Submitting.Please conatct ASD team.";
  alertmsgClass!: string;
  errModal!:ErrorModel;
  


  constructor(
    private _configLoaderService: ConfigLoaderService,
    private contactService: ContactusService,
    // public modalRef: MDBModalRef,
    public dialogRef: MatDialogRef<ContactModalComponent>,
    private _errorService:ErrorServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { 
    this.errModal=new ErrorModel();
    
  }

  ngOnInit() {
   
    this.errModal.ComponentName="ContactModalComponent";

    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.contactmodel.UserId = ConfigLoaderService.settings.DevValues.userName;
    }
    else{
      this.contactmodel.UserId=  ConfigLoaderService.settings.AppSettings.userId;     
    }
    this.getUsecaseList();
    this.getClientMarketList();
    this.getClientIndustryList();
  }


  getUsecaseList() {    
    this.errModal.MethodName="GetUseCaseList"; 
    this.errModal.ErrorMessage="Error getting UseCaseList";
    this.contactService
      .getUsecaseList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0){     
            this._errorService.handleError('',this.errModal) 
          }
          else
          {
            this.usecaselist = data;
          }           
        },
        (error) => {         
          this._errorService.handleError(error,this.errModal)
         
        }
      );
  }

  getClientMarketList() {
    this.errModal.MethodName="GetClientMarketList"; 
    this.errModal.ErrorMessage="Error getting ClientMarketList";

    this.contactService
      .getClientMarketList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data): any => {
          if (data === undefined || data.length == 0){     
            this._errorService.handleError('',this.errModal) 
          }
          else
          {
          this.clientmarketlist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error,this.errModal)
        }
      );
  }


  getClientIndustryList() {
    this.errModal.MethodName="GetClientIndustryList"; 
    this.errModal.ErrorMessage="Error getting ClientIndustryList";

    this.contactService
      .getClientIndustryList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0){     
            this._errorService.handleError('',this.errModal) 
          }
          else
          {
          this.clientindustrylist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error,this.errModal)
        }
      );
  }


  onSubmit() {
    this.errModal.MethodName="Submit"; 
    this.errModal.ErrorMessage="Error on Submitting Contact";
   

    this.contactService
      .submitDetails
      (
        this.contactmodel
      )
      .subscribe(
        (data:any) => {

          this.alertmsgClass = 'alert alert-success';
          this.alertMsg = this.successMessage;
          this.showalertMsg = true;        
          this.formreset();
     
        $("#success").toast("show");
        
        },
        (error:any) => {

          this.alertmsgClass = 'alert alert-danger';
          this.alertMsg = this.ErrorMessage;
          this.showalertMsg = true;
          this.formreset();
          $("#error").toast("show");
          this._errorService.handleError(error,this.errModal)
                 
        }
      );
  }
  closeAlert() {
    this.showalertMsg = false;
 
  }

  formreset() {

    this.contactform.resetForm();
    this.contactmodel.clientindustry='';
    this.contactmodel.clientmarket='';
    this.contactmodel.usecase='';
   
  }


}





